<template>
  <div class="review" :class="{ 'review-open': assignment.status === 'Open', 'review-hold': notOpen || assignment.status === 'HoldingUnproven' }">
    <div v-if="assignment.status === 'Open' || assignment.status === 'HoldingUnproven'" class="review-cancel grow tooltip" :class="{disabled: cancelInProgress}" @click="$store.commit('showCancelReview')">
        <i class="material-icons">close</i>
        <span class="tooltiptext">Cancel Request</span>
    </div>
    <v-container grid-list-md fluid pa-0>
      <v-layout row wrap>
        <v-flex md12>
          <div class="review-looking-image">
            <div class="review-looking-image-position">
              <img :src="imageUrl" class="review-looking-image-img" />
              <div class="review-looking-image-number">
                {{ assignment.looking_for_count }}
              </div>
            </div>
          </div>
          <div class="review-looking-content">
            <div v-if="assignment.status === 'HoldingUnproven'" class="content">
                This request is on hold.
            </div>
            <div v-if="assignment.status === 'Open'" class="content">
              <span v-if="notOpen">
                This request is scheduled to begin on <span class="assignment-date">{{ assignment.opened_at | shortDate }}</span>.
              </span>
              <span v-else>
                We're recommending your book and looking for a reader
                <span v-if="isScheduled">
                  until <span class="assignment-date">{{ assignment.closed_at | shortDate }}</span>
                </span>
                .
              </span>
            </div>
            <div v-if="assignment.status === 'Assigned'" class="content">
              A reader is currently reading your book.
            </div>

            <div class="estimate">
              <p v-if="assignment.status === 'Assigned'">
                Your reader has until
                <span class="assignment-date">{{
                  assignment.due_at | shortDate
                }}</span>
                (midnight EST) to turn in their review.
              </p>

              <p v-if="notOpen" class="started-line">
                You scheduled this request on
                <span class="assignment-date">{{
                  assignment.created_at | shortDate
                }}</span>
                .
              </p>
              <p v-else class="started-line">
                You started looking for this reader on
                <span  class="assignment-date">{{
                 assignment.opened_at ? assignment.opened_at : assignment.created_at | shortDate
                }}</span>
                .
              </p>
              <!-- <p v-if="assignment.status === 'Open'">It typically takes 1-3 days to find a reader.</p> -->
            </div>

            <status-messages
              v-if="assignment.status_messages"
              :assignment="assignment"
            ></status-messages>
          </div>
          <div class="clearfix"></div>

          <!-- <change-request
            v-if="showChangeRequest"
            :book="book"
            :assignment="assignment"
          ></change-request> -->

          <cancel-review-modal
            :assignment="assignment"
            :book="book"
            v-if="showCancelReview"
            @cancel-processing="processingCancel"
          ></cancel-review-modal>

          <assignment-footer :assignment="assignment"></assignment-footer>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import StatusMessages from "./StatusMessages";
import AssignmentFooter from "./AssignmentFooter";
import ChangeRequest from "../Book/ChangeRequest.vue";
import CancelReview from "@/components/Page/CancelReview";

import { mapState } from "vuex";

export default {
  name: "Review",
  components: {
    "status-messages": StatusMessages,
    AssignmentFooter,
    ChangeRequest,
    "cancel-review-modal": CancelReview,
  },
  props: ["assignment", "book"],
  data: function () {
    return {
      imageUrl: null,
      estimateText: null,
      showLongWaitMessage: false,
      showChangeRequest: false,
      isScheduled: false,
      notOpen: false,
      cancelInProgress: false,
    };
  },
  created() {},
  mounted() {
    if (this.assignment.status === "Open") {
      this.imageUrl = "/images/looking-for-reader.png";
      this.estimateText = this.decideEstimateText(this.assignment);
    }
    if (this.assignment.status === "Assigned") {
      this.imageUrl = "/images/reader.png";
    }
    if (this.assignment.status === "HoldingUnproven") {
      this.imageUrl = "/images/looking-on-hold.png";
    }

    this.showChangeRequest = this.assignment.status === "Open";

    if (this.assignment.opened_at || this.assignment.closed_at) {
      this.isScheduled = true
      if (this.assignment.opened_at) {
        const openAtTimestamp = new Date(this.assignment.opened_at.replace(/-/g, "/"));
        const now = new Date()
        if (openAtTimestamp > now) {
          this.notOpen = true
        }
      }
    }
  },
  computed: {
    ...mapState({
      showCancelReview: "showCancelReview",
    }),
  },
  methods: {
    processingCancel(value) {
      this.cancelInProgress = value;
    },
    decideEstimateText(assignment) {

      if (!assignment.estimated_reader_at) {
        return null;
      }

      const date = new Date(assignment.estimated_reader_at.replace(/-/g, "/"));

      var time = date.getTime() + 86400000;
      var earliestDate = new Date(time - 86400000 * 2 - 1);
      var latestDate = new Date(time + 86400000 - 1);

      var threshold = new Date().getTime() + 86400000 * 10;
      if (date.getTime() > threshold) {
        this.showLongWaitMessage = true;
      }

      // var earliestDate = new Date();
      // earliestDate.setDate(date.getDate() - 2);
      // var latestDate = new Date();
      // latestDate.setDate(date.getDate() + 1);

      // console.log(
      //   "luuk",
      //   earliestDate,
      //   latestDate,
      //   date,
      //   assignment.estimated_reader_at
      // );

      const now = new Date();
      const diff =
        date.getTime() - (now.getTime() - now.getTimezoneOffset() * 60 * 1000);
      if (earliestDate.getTime() < now.getTime()) {
        earliestDate = now;
      }

      const options = { month: "short", day: "numeric" };
      //return earliestDate.getTimezoneOffset() / 60;
      return (
        earliestDate.toLocaleDateString("en-US", options) +
        " - " +
        latestDate.toLocaleDateString("en-US", options)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.review {
  position: relative;
}
.content {
  font-size: 12pt;
  padding-bottom: 12px !important;
  padding-left: 0 !important;
}
.review-hold {
  background: #f4f4f4 !important;
  .content {
    padding-top: 22px;
    position: relative;
  }
}
.review-open .content {
  padding-top: 22px;
  position: relative;
  //padding-bottom: 4px !important;
}
.review-cancel {
  font-size: 15pt;
  padding: 7px 0 0 6.5px;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  position: absolute;
  top: -5px;
  right: -5px;
  color: #999;
  transition: all 0.2s ease-in-out;
}
.review-cancel:hover {
  background: #eee;
  transform: scale(1.1);
  cursor: pointer;
}
.review-cancel.disabled {
  color: #dbdbdb !important;
  pointer-events: none;
}
.estimate {
  padding-bottom: 12px;
  font-size: 11.5pt;
  color: #555;
}
.estimate p {
  padding: 0 !important;
  margin: 0 !important;
  margin-bottom: 2px !important;
}

.review {
  background: #fff;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin: 0 0 8px 0;
  padding: 8px 30px 14px 30px;
  border-radius: 8px;
  font-family: "Source Sans Pro";

  .review-looking-image {
    float: left;
    width: 80px;
  }
  .review-looking-image-position {
    position: relative;
  }
  .review-looking-content {
    padding-left: 90px;
  }

  .review-looking-image-img {
    width: 90%;
    margin: 22px 0 10px 0;
    position: absolute;
  }

  .review-looking-image-number {
    position: absolute;
    width: 28px;
    height: 28px;
    top: 46px;
    left: 46px;
    background-color: #fdead0;
    padding-top: 1px;
    color: #f57c00;
    font-weight: 700;
    font-family: $font-family;
    font-size: 12pt;
    border-radius: 100px;
    text-align: center;
  }
}

.review-open {
  .review-looking-image-number {
    top: 61px !important;
    background-color: darken(#daedff, 2%) !important;
    color: #2196f3 !important;
  }
}

.review-hold {
  .review-looking-image-number {
    top: 61px !important;
    background-color: darken(#f4f4f4, 9%) !important;
    color: #777 !important;
  }
}

.estimated-line {
  font-size: 12pt;
  color: darken(#f57c00, 7%);
  color: $color-blue;

  .estimated-date {
    font-weight: 600;
    background: lighten(#daedff, 2%);
    padding: 3px 8px;
    border-radius: 12px;
  }
}
.started-line {
  color: #777;
}

.star-rating {
  padding-top: 15px;
  text-align: left;
  flex-grow: 1;
}

.star-text {
  text-align: center;
  font-size: 12pt;
  font-family: "Source Sans Pro";
}

.details {
  display: flex;
  padding: 6px 0;
}

.assignment-date {
  font-weight: 600;
  //color: #444;
}

.author-and-date {
  display: flex;
}

.author {
  text-align: left;
  flex-grow: 0;
  padding-top: 14px;
  padding-left: 0.25em;
  color: $color-blue;
  font-size: 15pt;
  font-weight: 700;
  font-family: "Source Sans Pro";
}

.date {
  text-align: left;
  flex-grow: 1;
  padding-top: 14px;
  padding-left: 1em;
  color: lighten($color-blue, 0%);
  font-size: 15pt;
  font-weight: 500;
  font-family: "Source Sans Pro";
}

.content,
.pending-approval-content {
  padding: 1em 0.3em;
  font-size: 13.5pt;
  font-family: "Source Sans Pro";
  line-height: 1.5em;
}

.action {
  float: left;
  min-width: 148px;
  border-radius: 4px;
  padding: 8px 16px 9px 16px;
  font-size: 11pt;
  font-weight: 700;
  text-transform: none;
  font-family: "Source Sans Pro";
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 1px;
}

.view-on-amazon {
  margin-top: 9px;
  background: #daedff;
  color: #2196f3;
}

.tooltip {
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  font-size: 10pt !important;
  width: 120px;
  bottom: 100%;
  left: 50%;
  margin-left: -86px;
  text-align: center;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

</style>
